import React from "react";
import {STATIC_MODAL_COMPONENTS, STATIC_MODAL_LABEL, StaticFieldModalConfig} from "../DynamicFormTypes.ts";

interface StaticFieldModalWrapperProps {
    modalConfig: StaticFieldModalConfig,
    fieldKey: string
}

export const StaticFieldModalWrapper: React.FC<StaticFieldModalWrapperProps> = React.memo(({
                                                                                    modalConfig,
                                                                                    fieldKey,
                                                                                }) => {

    const [isOpen, setIsOpen] = React.useState(false);
    const ModalComponent = STATIC_MODAL_COMPONENTS[modalConfig.type];

    if (!ModalComponent) {
        console.error("Invalid modal type:", modalConfig.type);
        return null;
    }

    return (
        <>
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(true);
                }}
                className={"inline-flex items-center justify-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition duration-150"}
            >
                {STATIC_MODAL_LABEL[modalConfig.type]}
            </button>

            {isOpen && (
                <ModalComponent
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    fieldKey={fieldKey}
                    config={modalConfig}
                />
            )}
        </>
    );
});